import React, { useMemo } from "react";
import { FiDownload } from "react-icons/fi";
import { useTranslation } from "react-i18next";


import { openS3Document } from "../lib/documents";

function CorporateActions() {
  const { t } = useTranslation();

  const files = useMemo(
    () => [
      {
        key: "corporate-actions/capital_increase_27012025_IT.pdf",
        name: t("main.corporateActions.documents.capitalIncreaseIt"),
        date: "27/01/2025",
        sortDate: "2025-01-27",
      },
      {
        key: "corporate-actions/capital_increase_27012025_EN.pdf",
        name: t("main.corporateActions.documents.capitalIncreaseEn"),
        date: "27/01/2025",
        sortDate: "2025-01-27",
      },
      {
        key: "corporate-actions/20250121_capital_increase_notary_deed.pdf",
        name: t("main.corporateActions.documents.notaryDeedIt"),
        date: "24/01/2025",
        sortDate: "2025-01-24",
      },
      {
        key: "corporate-actions/20250121_capital_increase_notary_deed_EN.pdf",
        name: t("main.corporateActions.documents.notaryDeedEn"),
        date: "24/01/2025",
        sortDate: "2025-01-24",
      },
      {
        key: "corporate-actions/verbale_presa_atto_cda_IT.pdf",
        name: t("main.corporateActions.documents.boardMinutesIt"),
        date: "24/01/2025",
        sortDate: "2025-01-24",
      },
      {
        key: "corporate-actions/verbale_presa_atto_cda_EN.pdf",
        name: t("main.corporateActions.documents.boardMinutesEn"),
        date: "24/01/2025",
        sortDate: "2025-01-24",
      },
      {
        key: "corporate-actions/CapitalIncreaseSubscriptionForm_IT.pdf",
        name: t("main.corporateActions.documents.subscriptionFormIt"),
        date: "24/01/2025",
        sortDate: "2025-01-24",
      },
      {
        key: "corporate-actions/CapitalIncreaseSubscriptionForm_EN.pdf",
        name: t("main.corporateActions.documents.subscriptionFormEn"),
        date: "24/01/2025",
        sortDate: "2025-01-24",
      },
      {
        key: "corporate-actions/conclusionCapitalIncrease_IT.pdf",
        name: t("main.corporateActions.documents.conclusionCapitalIncreaseIt"),
        date: "",
        sortDate: "2025-01-23",
      },
      {
        key: "corporate-actions/conclusionCapitalIncrease_EN.pdf",
        name: t("main.corporateActions.documents.conclusionCapitalIncreaseEn"),
        date: "",
        sortDate: "2025-01-23",
      },
      {
        key: "corporate-actions/prospectusUnexercisedRights_IT.pdf",
        name: t("main.corporateActions.documents.unexercisedRightsIt"),
        date: "",
        sortDate: "2025-01-22",
      },
      {
        key: "corporate-actions/prospectusUnexercisedRights_EN.pdf",
        name: t("main.corporateActions.documents.unexercisedRightsEn"),
        date: "",
        sortDate: "2025-01-22",
      },
      {
        key: "corporate-actions/pressReleaseCapitalIncrease_IT.pdf",
        name: t("main.corporateActions.documents.pressReleaseIt"),
        date: "",
        sortDate: "2025-01-21",
      },
      {
        key: "corporate-actions/pressReleaseCapitalIncrease_EN.pdf",
        name: t("main.corporateActions.documents.pressReleaseEn"),
        date: "",
        sortDate: "2025-01-21",
      },
    ],
    [t]
  );

  const sortedFiles = useMemo(
    () =>
      [...files].sort((a, b) => {
        const dateA = new Date(a.sortDate || 0).getTime();
        const dateB = new Date(b.sortDate || 0).getTime();
        return dateB - dateA;
      }),
    [files]
  );

  return (
    <main className="corporate-page">
      <section className="corporate-hero">
        <div>
          <h1>{t("main.corporateActions.title")}</h1>
          <span />
        </div>
      </section>

      <section className="corporate-list-section">
        <div className="corporate-list">
          {sortedFiles.map((pdf) => (
            <div className="corporate-row" key={pdf.key}>
              <div className="corporate-text">
                <span>{pdf.name}</span>
                {pdf.date && <small>{pdf.date}</small>}
              </div>

              <a
                href="/"
                aria-label={`${t("main.common.download")} ${pdf.name}`}
                onClick={(event) => openS3Document(event, pdf.key)}
              >
                <FiDownload />
              </a>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

export default CorporateActions;